import React, { useState, useEffect } from 'react';
import MainCard from '../../../components/MainCard/MainCard';
import { Col, Row, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
//Components
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import RelatorioDemonstrativoDeColetasPorGerador from './RelatorioDemonstrativoDeColetasPorGerador';
//Api
import gerador_api from '../../../api/gerador_api';
import relatorio_api from '../../../api/relatorio_api';
//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");
    return {
        dataInicial,
        dataFinal,
        geradorId: null,
        geradorId_selected: null,
        nomeRelatorio: "Relatórios - Desmonstrativo de Coletas por Gerador"
    }
}

export default function DemonstrativoDeColetasPorGeradores() {
    //Variavel utilizada para navegação 
    const navigate = useNavigate();
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});
    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
    ]
    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Opções de transportadores
    const [optionsGeradores, setOptionsGeradores] = useState();

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Opções do select de status
    const optionsStatus = [
        { value: "TODOS", text: "Todos" },
        { value: "COLETADO", text: "Coletado" },
        { value: "BAIXADO", text: "Recebido" },
        { value: "NÃO COLETADO", text: "Recusado" },
    ]
    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e transportadores
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : null
        });
    }
    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }

        setLoading(true);
        const _filtros = { ...filtros }
        if (_filtros.regional_selected != null) {
            _filtros.regional = _filtros.regional_selected.label;
        }
        relatorio_api.DemonstrativoDeColetasPorGerador(_filtros).then(response => {
            response.data.listaColetas = response.data.listaColetas.map(coleta => {
                coleta.placaImplemento = coleta.veiculo + " / " + coleta.tipo_Veiculo
                if (coleta.dataHoraEmissao) {
                    coleta.dataHoraEmissao = moment(coleta.dataHoraEmissao).format("DD/MM/YYYY HH:mm:ss");
                }
                if (coleta.dataHoraColeta) {
                    coleta.dataHoraColeta = moment(coleta.dataHoraColeta).format("DD/MM/YYYY HH:mm:ss");
                }

                coleta.unidade = coleta.unidade ? coleta.unidade : "";
                coleta.volumeColetado =  coleta.volumeColetado ? String(coleta.volumeColetado).replace(".", ",") + " " + coleta.unidade: "0 " + coleta.unidade

                coleta.pesoEstimadoColeta = coleta.pesoEstimadoColeta ? String(coleta.pesoEstimadoColeta).replace(".", ",") + " KG" : "0 KG";
                coleta.pesoTotalEntradaDestino = coleta.pesoTotalEntradaDestino ? String(coleta.pesoTotalEntradaDestino).replace(".", ",") + " KG" : "0 KG";
                coleta.pesoTotalSaidaDestino = coleta.pesoTotalSaidaDestino ? String(coleta.pesoTotalSaidaDestino).replace(".", ",") + " KG" : "0 KG";

                Object.keys(coleta).map(value => {

                    if (!coleta[value]) {
                        coleta[value] = "Sem informação";
                    }
                });
                return coleta;
            });
            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));

    }
    //Carrega as modalidades de coleta, os geradores e as regionais para o select
    useEffect(() => {
        setLoading(true);
        gerador_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { label: value.fantasia, value: value.id }
            });
            setOptionsGeradores(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }, []);
    if (dadosRelatorio) {
        return <RelatorioDemonstrativoDeColetasPorGerador dadosRelatorio={dadosRelatorio} btnVoltar={() => setDadosRelatorio(null)} filtros={filtros} />
    }
    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório demonstrativo de coletas por gerador</h4>
            <Row>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataInicial" label={"* Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} invalid={!!errors.dataInicial} />
                    <PrintValidate field={"dataInicial"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataFinal" label={"* Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField placeholder='Todos' name="geradorId_selected" label={"Gerador"} type={"select"} searchable value={filtros.geradorId_selected} invalid={!!errors.geradorId_selected} onChange={onChangeSelected} options={optionsGeradores} />
                    <PrintValidate field={"geradorId_selected"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}